import React from "react"

import FooterStyle from "./style"

export const Footer = props => {
  return (
    <FooterStyle>
      <p>
        &copy; Caren Obligar {new Date().getFullYear()} | Made with{" "}
        <span role="image">❤️</span>{" "}
      </p>
    </FooterStyle>
  )
}

export default Footer
